import React, { useCallback, useEffect, useRef, useState } from 'react';
import { HiPlus } from 'react-icons/hi';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';

import Swal from 'sweetalert2';
import api from '~/services/api';
import getValidationErros from '~/utils/getValidationsErrors';

import { Container, Modal } from './styles';
import { KrClose } from '~/components/KoroIcons';
import InputFile from '~/components/InputFile';
import Toast from '~/utils/toast';

const Performance: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [user, setUser] = useState<string | null>(null);
  const [urlIframe, setUrlIframe] = useState('');
  const [show, setShow] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const [tempUrl, setTempUrl] = useState('');

  const handleShow = useCallback(() => {
    setShow(true);
  }, []);

  const { hostname } = window.location;

  useEffect(() => {
    if (hostname === 'admin.koro.com.br') {
      setUrlIframe(`https://report.koro.com.br`);
    } else {
      setUrlIframe(
        `https://s3.us-east-1.amazonaws.com/cdn.koro.com.br/html/Report_Koro_novo.html`
      );
    }
  }, [hostname, user]);

  useEffect(() => {
    const storedUser = localStorage.getItem('@Koro:user');
    setUser(storedUser);
  }, []);

  const handleChange = useCallback((files: File[]) => {
    setFile(files[0]);
  }, []);

  const handleSubmit = useCallback(
    async (data) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          file: Yup.string().test(
            'file',
            'O arquivo é obrigatório',
            (value) => {
              if (value) {
                return true;
              }
              return false;
            }
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        if (file) {
          const formData = new FormData();
          formData.append('file', file);
          await api.post('events/admin/performance', formData);
          setTempUrl(URL.createObjectURL(file));
          setShow(false);
          Toast.fire({
            icon: 'success',
            title: 'Arquivo enviado com sucesso',
          });
        }
      } catch (error) {
        if (error instanceof Yup.ValidationError) {
          const errors = getValidationErros(error);
          formRef.current?.setErrors(errors);
        } else {
          Swal.fire('Oops...', 'Ocorreu um erro ao enviar o arquivo.', 'error');
        }
      }
    },
    [file]
  );

  return (
    <Container>
      <div className="zoom col-12 px-0">
        <div className="bg-white d-sm-flex justify-content-between align-items-center p-4">
          <h1 className="mb-0">Performance</h1>
          <button
            type="button"
            onClick={handleShow}
            className="mb-0 h6 fw-normal text-white btn-new px-4 py-2"
          >
            <HiPlus size={16} color="#fff" className="me-2" />
            Upload
          </button>
        </div>
      </div>
      <div className="col-12 px-0 iframe-container">
        <iframe
          title="Performance"
          width="100%"
          height="100%"
          src={tempUrl || urlIframe}
        />
      </div>
      <Modal
        className="modal-filter"
        size="lg"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Form ref={formRef} onSubmit={handleSubmit}>
          <Modal.Header className="justify-content-between align-items-center border-0 px-3 px-sm-5 pb-0 pt-0">
            <Modal.Title className="mb-0 mt-4">
              <h2 className="title mb-0">Upload arquivo</h2>
            </Modal.Title>
            <button
              type="button"
              onClick={() => setShow(false)}
              className="border-0 bg-transparent"
            >
              <KrClose size={20} color="#989898" />
            </button>
          </Modal.Header>
          <Modal.Body className="pt-0 px-3 px-sm-5">
            <div className="row">
              <div className="col-12 py-4">
                <InputFile
                  name="file"
                  placeholder="Clique aqui ou arraste um arquivo"
                  onChange={handleChange}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="border-0 pb-4 px-5">
            <button type="submit" className="btn-filter rounded px-4 py-1">
              Enviar
            </button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* <Loading active={loading} text="Carregando..." /> */}
    </Container>
  );
};

export default Performance;
